import React from 'react'
import { LGPDProps } from '../../types/components/lgpd'
import { LGPDStyle } from './style'

export const LGPD: LGPDProps = ({ isVerify, setIsVerify }) => {
  return (
    <LGPDStyle isVerify={isVerify}>
      <p>Termo de consentimento para armazenamento e tratamento de dados pessoais em conformidade com a LGPD</p>
      <p>
        Este documento visa registrar a manifestação livre, informada e inequívoca pela qual o titular concorda com o
        tratamento de seus dados pessoais para finalidade específica, em conformidade com a Lei nº 13.709 – Lei Geral de
        Proteção de Dados Pessoais (LGPD).
      </p>
      <p>
        Informamos que coletamos seus dados pessoais (Nome e Celular) para fins de recrutamento e seleção de candidato.
      </p>
      {!isVerify ? (
        <button onClick={() => setIsVerify(true)}>Li e concordo com os termos</button>
      ) : (
        <button onClick={() => setIsVerify(false)}>Termo aceito</button>
      )}
    </LGPDStyle>
  )
}
